module.exports = __webpack_public_path__ + "img/guide.5ffe1ce8.png";